import React from "react";
import { BrowserRouter} from "react-router-dom";
import './index.css'
import {AppRoutes} from "./AppRoutes";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {LocalizationProvider} from "@mui/x-date-pickers";

const App: React.FC = () => {
  return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
          <BrowserRouter>
              <AppRoutes/>
          </BrowserRouter>
      </LocalizationProvider>
  );
};

export default App;